import { createContext } from 'react'

export interface OptimizelyContextProps {
  sessionId: string
  datafile: string
  overrides?: Record<string, string>
  attributes?: Record<string, string>
}

export const OptimizelyContext = createContext<OptimizelyContextProps | undefined>(undefined)
